var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"az-icon",style:(_setup.iconStyle)},[(_vm.iconName)?_c(require(`~/assets/images/icons/actions/${_vm.iconName}.svg?inline`),{tag:"component",attrs:{"aria-hidden":"true","focusable":"false"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }